<template lang="pug">
  button.event(
    @click="toggleEvent(event)"
    :class="classObject"
    :disabled="!isEventAvailable"
  )
    // Событие без выбора времени
    template(v-if="isTimeless")
      .event__time Без выбора времени
      EventPrice(v-if="isShowPrice" :price="event.price")
      .event__places
        | Оператор перезвонит для уточнения заказа

    // Обычное событие к определенному времени
    template(v-else)
      .event__time {{timeText}}
      EventPrice(v-if="isShowPrice" :price="event.price")
      .event__places(v-if="isShowAmount && !isNoAvailablePlaces")
        span.event__line-title Осталось:
        | {{event.amount.available}} из {{event.amount.total}}
      .event__places(v-if="isNoAvailablePlaces")
        | Нет мест
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import EventPrice from './EventPrice'

export default {
  name: 'Event',
  components: {
    EventPrice
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('event', ['isEventActive']),
    classObject() {
      return {
        timeless: this.isTimeless,
        active: this.isEventActive(this.event),
      }
    },
    timeText() {
      const date = new Date(this.event.timestamp * 1000);
      return date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'});
    },
    isShowPrice() {
      // TODO Прицепить настройку отображения цены из config
      return true;
    },
    isShowAmount() {
      const {amount} = this.event;
      return (
          amount
          && Object.prototype.hasOwnProperty.call(amount, 'available')
          && Object.prototype.hasOwnProperty.call(amount, 'total')
      );
    },
    isTimeless() {
      return !this.event.timestamp
    },
    isEventAvailable() {
      return this.event.available;
    },
    isNoAvailablePlaces() {
      return this.isShowAmount && this.event.amount.available === 0;
    },
  },
  methods: {
    ...mapActions('event', ['toggleEvent'])
  }
}
</script>
